import React, { useEffect, useState } from "react";
import { getNextLevel } from "utils/builder/IModelsTree";
import { treeAdd } from "utils/helpers";
import { useDashboardState } from "components/DashboardContext";
import "./ProjectNav.scss";

import ProjectNavItem from "components/uiComponents/ProjectNavItem";

const ProjectNav = ({
  isWithoutTitle,
  isWithoutSearch,
  outsideSearchValue = false,
}) => {
  const {
    foldersTree,
    setFoldersTree,
  } = useDashboardState();

  const [list, setList] = useState(null);
  const [searchValue, setSearchValue] = useState(null);
  const [tree, setTree] = useState({});

  useEffect(() => {
    // const treea = JSON.parse(localStorage.getItem("tree"));
    
    getNextLevel("#").then(res => {
      if (!foldersTree) {
        setFoldersTree(res);
      }
      
      setList(res);
    });

    // setTree(treea ? treea : {});
  }, []);

  useEffect(() => {
    if (!!outsideSearchValue || outsideSearchValue === '') {
      setSearchValue(outsideSearchValue);
    }
  }, [outsideSearchValue]);

  const treeAction = (id, list, condition, level) => {
    setTree((prevState) => {
      const tempOBj = { ...prevState };
      const result = treeAdd(tempOBj, id, list, condition, level);

      localStorage.setItem("tree", JSON.stringify(result));

      return result;
    });
  };

  const handleSearch = (e) => {
    if (!list) return;

    const value = e.target.value;

    if (e.keyCode === 13) {
      setSearchValue(value);
    }
  };

  return (
    <>
      {!isWithoutSearch &&
        <div>
          <input
            type="text"
            name="sideSearch"
            className="search"
            placeholder="Search your project..."
            onKeyUp={handleSearch}
          />
        </div>
      }

      <div className="project-nav__folders">
        {!isWithoutTitle &&
          <h5>Folder</h5>
        }

        {list &&
          list.map(el => {
            return (
              <ProjectNavItem
                item={el}
                key={el.id}
                treeAction={treeAction}
                searchValue={searchValue}
                level={1}
              />
            );
          })}
      </div>
    </>
  );
};

export default ProjectNav;
